import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent implements OnInit {

  endorsement = {};

  constructor() {}

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/jonshilton/Projects/nick-smith-app/src/app/pages/testimonials/testimonials.component.ts